import React from 'react';
import styles from './NewsTicker.module.css';

const NewsTicker = () => {
  const messages = [
    '🚚 All Gujarat – FREE Delivery!',
    '🧈 Health, Taste & Tradition in Every Spoon!',
    '🐂 Pure Gir Cow Ghee',
    '✨ 100% Natural & Chemical Free',
    '🏡 Farm Fresh to Your Home',
    '🥄 Traditional Bilona Method',
  ];

  return (
    <div className={styles.tickerContainer}>
      <div className={styles.tickerWrapper}>
        <div className={styles.tickerContent}>
          {messages.map((message, index) => (
            <span key={index} className={styles.tickerItem}>
              {message}
            </span>
          ))}
          {/* Duplicate for seamless loop */}
          {messages.map((message, index) => (
            <span key={`duplicate-${index}`} className={styles.tickerItem}>
              {message}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
};

export default NewsTicker;
